import React from 'react'

import { Helmet } from 'react-helmet'

import Menu from '../components/menu'
import './consultas.css'

const Consultas = (props) => {
  return (
    <div className="consultas-container">
      <Helmet>
        <title>Consultas - Marchetti</title>
        <meta name="description" content="Marchetti" />
        <meta property="og:title" content="Consultas - Marchetti" />
        <meta property="og:description" content="Marchetti" />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/cddaa0fe-329b-4980-ac51-175c84c5aca3/4e8ea9c2-19aa-4f93-a94f-0a54c9bae130?org_if_sml=1"
        />
      </Helmet>
      <Menu rootClassName="menu-root-class-name1"></Menu>
      <div className="consultas-bienvenida-enfocados">
        <div className="consultas-banner">
          <h1 className="consultas-text">
            <span>
              Consultas Personalizadas
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span>a la #MarchettiRules</span>
          </h1>
        </div>
      </div>
      <div className="consultas-banner1">
        <span className="consultas-text03">
          <span>
            <span>
              Una gran manera de comenzar a generar un cambio positivo, es
              mediante nuestras elecciones y sobre todo aplicar la organización
              que promuevo desde Marchettirules, ya que es clave, para ahorrar
              tiempo, dinero y no caer en tentaciones. Poner esto en práctica
              son algunos de los beneficios, y te permite mantenerte ¨enfocado¨
              (otro concepto clave), y con energía para todo el día. Aprender a
              comer saludable, y lograr tus objetivos es posible.
            </span>
          </span>
        </span>
        <div className="consultas-testimonial">
          <img
            alt="image"
            src="/playground_assets/bk5a8638-300h.jpg"
            className="consultas-image"
          />
          <div className="consultas-testimonial1">
            <div className="consultas-container01">
              <svg
                viewBox="0 0 950.8571428571428 1024"
                className="consultas-icon"
              >
                <path d="M438.857 548.571v219.429c0 60.571-49.143 109.714-109.714 109.714h-219.429c-60.571 0-109.714-49.143-109.714-109.714v-402.286c0-161.143 131.429-292.571 292.571-292.571h36.571c20 0 36.571 16.571 36.571 36.571v73.143c0 20-16.571 36.571-36.571 36.571h-36.571c-80.571 0-146.286 65.714-146.286 146.286v18.286c0 30.286 24.571 54.857 54.857 54.857h128c60.571 0 109.714 49.143 109.714 109.714zM950.857 548.571v219.429c0 60.571-49.143 109.714-109.714 109.714h-219.429c-60.571 0-109.714-49.143-109.714-109.714v-402.286c0-161.143 131.429-292.571 292.571-292.571h36.571c20 0 36.571 16.571 36.571 36.571v73.143c0 20-16.571 36.571-36.571 36.571h-36.571c-80.571 0-146.286 65.714-146.286 146.286v18.286c0 30.286 24.571 54.857 54.857 54.857h128c60.571 0 109.714 49.143 109.714 109.714z"></path>
              </svg>
            </div>
            <span className="consultas-text06">
              <span>
                Desde los 15 años me apasiona la nutrición, la actividad física,
                la estética y los hábitos saludables. Descubrí mi pasión por la
                nutrición desde muy chico y estoy seguro que fue por una linda
                casualidad.
              </span>
              <br></br>
              <span></span>
            </span>
            <div className="consultas-container02">
              <svg
                viewBox="0 0 950.8571428571428 1024"
                className="consultas-icon02"
              >
                <path d="M438.857 182.857v402.286c0 161.143-131.429 292.571-292.571 292.571h-36.571c-20 0-36.571-16.571-36.571-36.571v-73.143c0-20 16.571-36.571 36.571-36.571h36.571c80.571 0 146.286-65.714 146.286-146.286v-18.286c0-30.286-24.571-54.857-54.857-54.857h-128c-60.571 0-109.714-49.143-109.714-109.714v-219.429c0-60.571 49.143-109.714 109.714-109.714h219.429c60.571 0 109.714 49.143 109.714 109.714zM950.857 182.857v402.286c0 161.143-131.429 292.571-292.571 292.571h-36.571c-20 0-36.571-16.571-36.571-36.571v-73.143c0-20 16.571-36.571 36.571-36.571h36.571c80.571 0 146.286-65.714 146.286-146.286v-18.286c0-30.286-24.571-54.857-54.857-54.857h-128c-60.571 0-109.714-49.143-109.714-109.714v-219.429c0-60.571 49.143-109.714 109.714-109.714h219.429c60.571 0 109.714 49.143 109.714 109.714z"></path>
              </svg>
            </div>
          </div>
          <a
            href="https://api.whatsapp.com/send?phone=5491162430189&amp;text=Hola%20Mat%C3%ADas%2C%20%C2%BFC%C3%B3mo%20estas%3F%20Me%20interesa%20tener%20una%20consulta%20con%20vos%20%C2%BFMe%20podr%C3%ADas%20dar%20m%C3%A1s%20informaci%C3%B3n%20por%20favor%3F%20Gracias"
            target="_blank"
            rel="noreferrer noopener"
            className="consultas-link"
          >
            <img
              alt="image"
              src="/playground_assets/887423_text_512x512-200h.png"
              className="consultas-image1"
            />
          </a>
          <span className="consultas-text09">
            <span>Matias Marchetti</span>
          </span>
          <span className="consultas-text11">
            <span className="consultas-text12">
              Creador del Método #MarchettiRules®
            </span>
          </span>
        </div>
        <div className="consultas-testimonial2">
          <div className="consultas-container03">
            <h1 className="consultas-text13">
              <span>
                Y con el Equipo de Nutricionistas
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>certificadas en el Método #MarchettiRulesc</span>
              <span className="consultas-text17"></span>
              <span></span>
            </h1>
            <div className="consultas-testimonial-card"></div>
            <div className="consultas-container04"></div>
            <div className="consultas-container05">
              <div className="consultas-florencia">
                <img
                  alt="profile"
                  src="/playground_assets/28-1400w.jpg"
                  loading="eager"
                  className="consultas-image2"
                />
                <div className="consultas-container06"></div>
                <span className="consultas-text19">
                  <span className="consultas-text20">
                    Florencia
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="consultas-text21">Falco</span>
                </span>
                <span className="consultas-text22">
                  <span className="consultas-text23">Lic. en Nutrición</span>
                  <br></br>
                  <span></span>
                  <span className="consultas-text26"></span>
                  <span className="consultas-text27">M.N 10751</span>
                </span>
                <span className="consultas-text28">
                  Soy vegetariana e hice varios cursos sobre alimentación basada
                  en plantas ¡Me encanta! Pero también, puedo acompañarte en
                  cualquier patrón de alimentación que elijas. Además, me
                  interesa mucho la salud gastrointestinal y puedo ayudarte a
                  mejorarla.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <a
                  href="https://api.whatsapp.com/send?phone=5491125295667&amp;text=Hola,%20soy%20de%20la%20ComunidadMR%20y%20quiero%20un%20turno%20con%20Flor."
                  target="_blank"
                  rel="noreferrer noopener"
                  className="consultas-link01"
                >
                  <img
                    alt="image"
                    src="/playground_assets/887423_text_512x512-200h.png"
                    className="consultas-image3"
                  />
                </a>
              </div>
              <div className="consultas-carolina">
                <img
                  alt="profile"
                  src="/playground_assets/29-1400w.jpg"
                  loading="eager"
                  className="consultas-image4"
                />
                <div className="consultas-container07"></div>
                <span className="consultas-text29">
                  <span>
                    Carolina
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>Pagliari</span>
                </span>
                <span className="consultas-text32">
                  <span className="consultas-text33">Lic. en Nutrición</span>
                  <br></br>
                  <span></span>
                  <span className="consultas-text36"></span>
                  <span className="consultas-text37">M.P 4676</span>
                </span>
                <span className="consultas-text38">
                  <span>
                    Soy nutri y antopometrista ISAK I. Amo el deporte,
                    especialmente el básquet. Me especialice en nutrición
                    deportiva y en nutrición familiar e integral, formándome en
                    alimentación complementaria y BLW.
                  </span>
                  <br></br>
                  <span></span>
                </span>
                <a
                  href="https://api.whatsapp.com/send?phone=5491125295667&amp;text=Hola,%20soy%20de%20la%20ComunidadMR%20y%20quiero%20un%20turno%20con%20Flor."
                  target="_blank"
                  rel="noreferrer noopener"
                  className="consultas-link02"
                >
                  <img
                    alt="image"
                    src="/playground_assets/887423_text_512x512-200h.png"
                    className="consultas-image5"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="consultas-steps">
        <h1 className="consultas-text42">
          <span>¿Cómo empezar?</span>
        </h1>
        <span className="consultas-text44">
          <span>Viví la experiencia personalizada a la #MarchettiRules®</span>
          <span></span>
        </span>
        <div className="consultas-container08">
          <div className="consultas-step">
            <div className="consultas-container09">
              <div className="consultas-line"></div>
              <div className="consultas-container10">
                <svg viewBox="0 0 1024 1024" className="consultas-icon04">
                  <path d="M960 608l-288 288-96-96-64 64 160 160 352-352z"></path>
                  <path d="M448 768h320v-115.128c-67.22-39.2-156.308-66.11-256-74.26v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h448v-64z"></path>
                </svg>
              </div>
              <div className="consultas-line1"></div>
            </div>
            <div className="consultas-container11">
              <h1 className="consultas-text47">
                <span>Protagonista</span>
              </h1>
              <span className="consultas-text49">
                <span>Decidis cambiar tu actual estio de vida</span>
                <br></br>
                <span></span>
              </span>
            </div>
          </div>
          <div className="consultas-step1">
            <div className="consultas-container12">
              <div className="consultas-line2"></div>
              <div className="consultas-container13">
                <svg viewBox="0 0 1024 1024" className="consultas-icon07">
                  <path d="M768 768v-42q0-58-88-95t-168-37-168 37-88 95v42h512zM512 256q-52 0-90 38t-38 90 38 90 90 38 90-38 38-90-38-90-90-38zM810 128q34 0 60 26t26 60v596q0 34-26 60t-60 26h-596q-36 0-61-25t-25-61v-596q0-36 25-61t61-25h42v-86h86v86h340v-86h86v86h42z"></path>
                </svg>
              </div>
              <div className="consultas-line3"></div>
            </div>
            <div className="consultas-container14">
              <h1 className="consultas-text52">Online o Presencial</h1>
              <span className="consultas-text53">
                <span>
                  Elegis la modaliidad que mejor se adapte a tu preferencia y
                  profesional
                </span>
              </span>
            </div>
          </div>
          <div className="consultas-step2">
            <div className="consultas-container15">
              <div className="consultas-line4"></div>
              <div className="consultas-container16">
                <a
                  href="https://api.whatsapp.com/send?phone=5491125295667&amp;text=Hola,%20soy%20de%20la%20ComunidadMR%20y%20quiero%20info%20sobre%20turno"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="consultas-link03"
                >
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="consultas-icon09"
                  >
                    <path d="M562.857 556.571c9.714 0 102.857 48.571 106.857 55.429 1.143 2.857 1.143 6.286 1.143 8.571 0 14.286-4.571 30.286-9.714 43.429-13.143 32-66.286 52.571-98.857 52.571-27.429 0-84-24-108.571-35.429-81.714-37.143-132.571-100.571-181.714-173.143-21.714-32-41.143-71.429-40.571-110.857v-4.571c1.143-37.714 14.857-64.571 42.286-90.286 8.571-8 17.714-12.571 29.714-12.571 6.857 0 13.714 1.714 21.143 1.714 15.429 0 18.286 4.571 24 19.429 4 9.714 33.143 87.429 33.143 93.143 0 21.714-39.429 46.286-39.429 59.429 0 2.857 1.143 5.714 2.857 8.571 12.571 26.857 36.571 57.714 58.286 78.286 26.286 25.143 54.286 41.714 86.286 57.714 4 2.286 8 4 12.571 4 17.143 0 45.714-55.429 60.571-55.429zM446.857 859.429c197.714 0 358.857-161.143 358.857-358.857s-161.143-358.857-358.857-358.857-358.857 161.143-358.857 358.857c0 75.429 24 149.143 68.571 210.286l-45.143 133.143 138.286-44c58.286 38.286 127.429 59.429 197.143 59.429zM446.857 69.714c237.714 0 430.857 193.143 430.857 430.857s-193.143 430.857-430.857 430.857c-72.571 0-144.571-18.286-208.571-53.714l-238.286 76.571 77.714-231.429c-40.571-66.857-61.714-144-61.714-222.286 0-237.714 193.143-430.857 430.857-430.857z"></path>
                  </svg>
                </a>
              </div>
              <div className="consultas-line5"></div>
            </div>
            <div className="consultas-container17">
              <h1 className="consultas-text55">
                <span>Contacto</span>
              </h1>
              <span className="consultas-text57">
                <span>Coordinamos día y horario</span>
              </span>
            </div>
          </div>
          <div className="consultas-step3">
            <div className="consultas-container18">
              <div className="consultas-line6"></div>
              <div className="consultas-container19">
                <svg
                  viewBox="0 0 950.8571428571428 1024"
                  className="consultas-icon11"
                >
                  <path d="M950.857 369.714c0 10.286-7.429 20-14.857 27.429l-207.429 202.286 49.143 285.714c0.571 4 0.571 7.429 0.571 11.429 0 14.857-6.857 28.571-23.429 28.571-8 0-16-2.857-22.857-6.857l-256.571-134.857-256.571 134.857c-7.429 4-14.857 6.857-22.857 6.857-16.571 0-24-13.714-24-28.571 0-4 0.571-7.429 1.143-11.429l49.143-285.714-208-202.286c-6.857-7.429-14.286-17.143-14.286-27.429 0-17.143 17.714-24 32-26.286l286.857-41.714 128.571-260c5.143-10.857 14.857-23.429 28-23.429s22.857 12.571 28 23.429l128.571 260 286.857 41.714c13.714 2.286 32 9.143 32 26.286z"></path>
                </svg>
              </div>
              <div className="consultas-line7"></div>
            </div>
            <div className="consultas-container20">
              <h1 className="consultas-text59">
                <span>Comenzás a vivir la experiencia a la #MR</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="consultas-testimonial3">
        <div className="consultas-container21">
          <h1 className="consultas-text61">
            <span className="consultas-text62">
              ¿Preferis hacerlo en Equipo?
            </span>
            <br></br>
            <span>Sumaté a nuestros Equipos de Enfocad@s</span>
            <span className="consultas-text65"></span>
          </h1>
          <div className="consultas-container22"></div>
          <a
            href="https://api.whatsapp.com/send?phone=5491125295667&amp;text=Hola,%20soy%20de%20la%20ComunidadMR%20y%20quiero%20sumarme%20a%20los%20Equipos%20de%20Enfocad@s."
            target="_blank"
            rel="noreferrer noopener"
            className="consultas-link04"
          >
            <img
              alt="image"
              src="/playground_assets/887423_text_512x512-200h.png"
              className="consultas-image6"
            />
          </a>
          <span className="consultas-text66">Escribinos para + Info</span>
        </div>
      </div>
      <div className="consultas-container23">
        <footer className="consultas-footer">
          <img
            alt="logo"
            src="/playground_assets/%23mr.svg"
            className="consultas-image7"
          />
          <span className="consultas-text67">© 2022 All Rights Reserved.</span>
          <div className="consultas-icon-group">
            <a
              href="https://www.instagram.com/matias.marchetti/"
              target="_blank"
              rel="noreferrer noopener"
              className="consultas-link05"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="consultas-icon13"
              >
                <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/LicMatiasMarchetti/"
              target="_blank"
              rel="noreferrer noopener"
              className="consultas-link06"
            >
              <svg
                viewBox="0 0 602.2582857142856 1024"
                className="consultas-icon15"
              >
                <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
              </svg>
            </a>
            <a
              href="https://ar.pinterest.com/MarchettiRules/"
              target="_blank"
              rel="noreferrer noopener"
              className="consultas-link07"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="consultas-icon17"
              >
                <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857-43.429 0-84.571-6.286-124.571-18.286 16.571-26.286 35.429-60 44.571-93.714 0 0 5.143-19.429 30.857-120.571 14.857 29.143 59.429 54.857 106.857 54.857 141.143 0 237.143-128.571 237.143-301.143 0-129.714-110.286-251.429-278.286-251.429-208 0-313.143 149.714-313.143 274.286 0 75.429 28.571 142.857 89.714 168 9.714 4 18.857 0 21.714-11.429 2.286-7.429 6.857-26.857 9.143-34.857 2.857-11.429 1.714-14.857-6.286-24.571-17.714-21.143-29.143-48-29.143-86.286 0-110.857 82.857-210.286 216-210.286 117.714 0 182.857 72 182.857 168.571 0 126.286-56 233.143-139.429 233.143-45.714 0-80-37.714-69.143-84.571 13.143-55.429 38.857-115.429 38.857-155.429 0-36-19.429-66.286-59.429-66.286-46.857 0-84.571 48.571-84.571 113.714 0 0 0 41.714 14.286 69.714-48 203.429-56.571 238.857-56.571 238.857-8 33.143-8.571 70.286-7.429 101.143-154.857-68-262.857-222.286-262.857-402.286 0-242.286 196.571-438.857 438.857-438.857s438.857 196.571 438.857 438.857z"></path>
              </svg>
            </a>
            <a
              href="https://ar.linkedin.com/in/matias-marchetti"
              target="_blank"
              rel="noreferrer noopener"
              className="consultas-link08"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="consultas-icon19"
              >
                <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
              </svg>
            </a>
            <a
              href="https://twitter.com/marchettirules?lang=bg "
              target="_blank"
              rel="noreferrer noopener"
              className="consultas-link09"
            >
              <svg
                viewBox="0 0 950.8571428571428 1024"
                className="consultas-icon21"
              >
                <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/channel/UCLqCGfv-_ColrjRT9gqejdQ "
              target="_blank"
              rel="noreferrer noopener"
              className="consultas-link10"
            >
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="consultas-icon23"
              >
                <path d="M525.143 744.571v-89.714c0-18.857-5.714-28.571-16.571-28.571-6.286 0-12.571 2.857-18.857 9.143v128c6.286 6.286 12.571 9.143 18.857 9.143 10.857 0 16.571-9.143 16.571-28zM630.286 674.857h37.714v-19.429c0-19.429-6.286-29.143-18.857-29.143s-18.857 9.714-18.857 29.143v19.429zM304 522.857v40h-45.714v241.714h-42.286v-241.714h-44.571v-40h132.571zM418.857 594.857v209.714h-38.286v-22.857c-14.857 17.143-29.143 25.714-43.429 25.714-12 0-20.571-5.143-24-16-2.286-6.286-3.429-16-3.429-30.857v-165.714h37.714v154.286c0 8.571 0 13.714 0.571 14.857 0.571 5.714 3.429 8.571 8.571 8.571 8 0 15.429-5.714 24-17.714v-160h38.286zM562.857 658.286v83.429c0 18.857-1.143 33.143-4 41.714-4.571 16-14.857 24-30.286 24-13.143 0-26.286-8-38.857-23.429v20.571h-38.286v-281.714h38.286v92c12-14.857 25.143-22.857 38.857-22.857 15.429 0 25.714 8 30.286 24 2.857 8.571 4 22.286 4 42.286zM706.286 732v5.143c0 12.571-0.571 20.571-1.143 24.571-1.143 8.571-4 16-8.571 22.857-10.286 15.429-26.286 22.857-45.714 22.857-20 0-35.429-7.429-46.286-21.714-8-10.286-12-26.857-12-49.143v-73.714c0-22.286 3.429-38.286 11.429-49.143 10.857-14.286 26.286-21.714 45.714-21.714 18.857 0 34.286 7.429 44.571 21.714 8 10.857 12 26.857 12 49.143v43.429h-76v37.143c0 19.429 6.286 29.143 19.429 29.143 9.143 0 14.857-5.143 17.143-14.857 0-2.286 0.571-10.857 0.571-25.714h38.857zM448.571 261.143v89.143c0 19.429-6.286 29.143-18.286 29.143-12.571 0-18.286-9.714-18.286-29.143v-89.143c0-19.429 5.714-29.714 18.286-29.714 12 0 18.286 10.286 18.286 29.714zM753.143 668.571v0c0-49.143 0-101.143-10.857-148.571-8-33.714-35.429-58.286-68-61.714-77.714-8.571-156.571-8.571-235.429-8.571-78.286 0-157.143 0-234.857 8.571-33.143 3.429-60.571 28-68 61.714-10.857 47.429-11.429 99.429-11.429 148.571v0c0 48.571 0 100.571 11.429 148.571 7.429 33.143 34.857 57.714 67.429 61.714 78.286 8.571 157.143 8.571 235.429 8.571s157.143 0 235.429-8.571c32.571-4 60-28.571 67.429-61.714 11.429-48 11.429-100 11.429-148.571zM321.714 296.571l51.429-169.143h-42.857l-29.143 111.429-30.286-111.429h-44.571c8.571 26.286 18.286 52.571 26.857 78.857 13.714 40 22.286 69.714 26.286 90.286v114.857h42.286v-114.857zM486.857 342.857v-74.286c0-22.286-4-38.857-12-49.714-10.857-14.286-25.714-21.714-44.571-21.714-19.429 0-34.286 7.429-44.571 21.714-8 10.857-12 27.429-12 49.714v74.286c0 22.286 4 38.857 12 49.714 10.286 14.286 25.143 21.714 44.571 21.714 18.857 0 33.714-7.429 44.571-21.714 8-10.286 12-27.429 12-49.714zM590.286 411.429h38.286v-211.429h-38.286v161.714c-8.571 12-16.571 17.714-24 17.714-5.143 0-8.571-2.857-9.143-9.143-0.571-1.143-0.571-5.714-0.571-14.857v-155.429h-38.286v167.429c0 14.857 1.143 24.571 3.429 31.429 4 10.286 12.571 15.429 24.571 15.429 14.286 0 28.571-8.571 44-25.714v22.857zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
              </svg>
            </a>
            <a
              href="https://www.instagram.com/marchettirules/ "
              target="_blank"
              rel="noreferrer noopener"
              className="consultas-link11"
            >
              <svg viewBox="0 0 1024 1024" className="consultas-icon25">
                <path d="M512 92.2c136.8 0 153 0.6 206.8 3 50 2.2 77 10.6 95 17.6 23.8 9.2 41 20.4 58.8 38.2 18 18 29 35 38.4 58.8 7 18 15.4 45.2 17.6 95 2.4 54 3 70.2 3 206.8s-0.6 153-3 206.8c-2.2 50-10.6 77-17.6 95-9.2 23.8-20.4 41-38.2 58.8-18 18-35 29-58.8 38.4-18 7-45.2 15.4-95 17.6-54 2.4-70.2 3-206.8 3s-153-0.6-206.8-3c-50-2.2-77-10.6-95-17.6-23.8-9.2-41-20.4-58.8-38.2-18-18-29-35-38.4-58.8-7-18-15.4-45.2-17.6-95-2.4-54-3-70.2-3-206.8s0.6-153 3-206.8c2.2-50 10.6-77 17.6-95 9.2-23.8 20.4-41 38.2-58.8 18-18 35-29 58.8-38.4 18-7 45.2-15.4 95-17.6 53.8-2.4 70-3 206.8-3zM512 0c-139 0-156.4 0.6-211 3-54.4 2.4-91.8 11.2-124.2 23.8-33.8 13.2-62.4 30.6-90.8 59.2-28.6 28.4-46 57-59.2 90.6-12.6 32.6-21.4 69.8-23.8 124.2-2.4 54.8-3 72.2-3 211.2s0.6 156.4 3 211c2.4 54.4 11.2 91.8 23.8 124.2 13.2 33.8 30.6 62.4 59.2 90.8 28.4 28.4 57 46 90.6 59 32.6 12.6 69.8 21.4 124.2 23.8 54.6 2.4 72 3 211 3s156.4-0.6 211-3c54.4-2.4 91.8-11.2 124.2-23.8 33.6-13 62.2-30.6 90.6-59s46-57 59-90.6c12.6-32.6 21.4-69.8 23.8-124.2 2.4-54.6 3-72 3-211s-0.6-156.4-3-211c-2.4-54.4-11.2-91.8-23.8-124.2-12.6-34-30-62.6-58.6-91-28.4-28.4-57-46-90.6-59-32.6-12.6-69.8-21.4-124.2-23.8-54.8-2.6-72.2-3.2-211.2-3.2v0z"></path>
                <path d="M512 249c-145.2 0-263 117.8-263 263s117.8 263 263 263 263-117.8 263-263c0-145.2-117.8-263-263-263zM512 682.6c-94.2 0-170.6-76.4-170.6-170.6s76.4-170.6 170.6-170.6c94.2 0 170.6 76.4 170.6 170.6s-76.4 170.6-170.6 170.6z"></path>
                <path d="M846.8 238.6c0 33.91-27.49 61.4-61.4 61.4s-61.4-27.49-61.4-61.4c0-33.91 27.49-61.4 61.4-61.4s61.4 27.49 61.4 61.4z"></path>
              </svg>
            </a>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default Consultas
